import React from 'react';

const ChaletSearchResultsIntroText = ({ inspireMeAttributeId }) => {
    return (
        <div>
            {inspireMeAttributeId === 22 && (
                <div className="container my-5">
                    <div className="row">
                        <div className="mx-auto">
                            <h1>
                                Recommended Ski Chalets for Christmas Skiing in the Alps: Snow-Sure and Family-Friendly
                            </h1>
                            <p className="lead text-justify">
                                Looking to spend Christmas in a cosy ski chalet nestled in the snow-covered Alps? Whether you're planning
                                a family-friendly ski holiday or looking for luxury ski chalets with guaranteed snow, we've got you covered.
                                The Alps offer some of the best Christmas ski chalets, perfect for enjoying the festive season in a true winter
                                wonderland.
                            </p>
                            <p className="lead text-justify">
                                Our top picks include family-friendly ski chalets in snow-sure resorts, where the whole family can enjoy Christmas
                                skiing with peace of mind. If you're after a touch of luxury, we've also curated a selection of chalets that
                                provide not only stunning mountain views but also the perfect setting for a magical Christmas ski holiday.
                            </p>
                            <p className="lead text-justify">
                                From the best Christmas skiing destinations in the Alps to affordable options for those seeking a budget-friendly
                                getaway, we've compiled the ultimate guide to finding the perfect ski chalet for your Christmas adventure. Whether
                                you're dreaming of snow-sure Christmas skiing or a relaxing holiday in a charming chalet, the Alps have it all.
                            </p>
                        </div>
                    </div>
                </div>
            )}
            {inspireMeAttributeId === 25 && (
                <div class="container my-5">
                    <div class="row">
                        <div class="mx-auto">
                            <h2>
                                Celebrate New Year's Eve in the Alps - Ski Chalets for an Unforgettable Start to the Year!
                            </h2>
                            <p class="lead text-justify">
                                Ready to ring in the New Year in a spectacular winter wonderland? Our selection of ski chalets for New Year's skiing in the Alps offers the ultimate festive experience, combining breathtaking alpine views, snow-sure conditions, and the excitement of the holiday season. Whether you're planning a lively New Year's Eve celebration or a serene getaway, we've curated chalets that will make your winter holiday one to remember.
                            </p>
                            <p class="lead text-justify">
                                For those looking to start the year off with adventure, the Alps provide world-class skiing, from beginner-friendly slopes to challenging runs for seasoned skiers. After a thrilling day on the slopes, enjoy a cozy evening in one of our handpicked chalets, perfect for a group celebration or an intimate retreat. With options ranging from luxury accommodations to budget-friendly chalets, we ensure that every traveler can enjoy the perfect New Year ski escape.
                            </p>
                            <p class="lead text-justify">
                                Imagine spending New Year's Eve under the stars, surrounded by snow-capped peaks, and waking up to a fresh day of skiing in some of the most scenic resorts in the world. Whether you prefer the lively atmosphere of apres-ski parties or a quiet evening by the fire, these chalets provide the ideal setting for a memorable celebration. Start the year off right by booking your New Year ski holiday in the Alps now!
                            </p>
                            <p class="lead text-justify">
                                Explore our top-rated New Year's ski chalets below and find the perfect match for your holiday. Whether you're seeking a high-end luxury chalet or a charming, affordable stay, we've got options that cater to all budgets and preferences. Let us help you plan an unforgettable New Year ski adventure in the Alps!
                            </p>
                        </div>
                    </div>
                </div>


            )}
            {inspireMeAttributeId === 311 && (
                <div>
                    <h1>Family-Friendly Ski Holidays</h1>
                    <p>
                        Looking for a family-friendly ski holiday? We�ve rounded up the best chalets in top-rated resorts
                        where the whole family can enjoy skiing in a safe and enjoyable environment, with activities and
                        amenities for all ages.
                    </p>
                </div>
            )}
            {inspireMeAttributeId === 411 && (
                <div>
                    <h1>Budget-Friendly Ski Holidays</h1>
                    <p>
                        Planning a budget-friendly ski holiday? We've handpicked affordable yet charming ski chalets
                        that offer excellent value without compromising on quality, ensuring you get the best experience
                        for your money.
                    </p>
                </div>
            )}
            {/* Add more cases as needed */}
        </div>
    );
};

export default ChaletSearchResultsIntroText;
